export const isSafariBrowser = (): boolean => {
    if (typeof navigator === "undefined" || !navigator.userAgent) return false;

    return /Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|Chromium|Edg|OPR|FxiOS/i.test(navigator.userAgent);
};
